// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"597f5948","232":"5b96732b","237":"57c81702","357":"d99254a0","526":"239463d0","573":"60cb69de","787":"052351e8","872":"8e4d1168"}[chunkId] + ".chunk.js";
};